import { TableColumn, TableConfig } from 'src/app/@shared/models/table.models';

export const VENDOR_MATERIALS_COLUMNS: TableColumn[] = [
    { field: 'workName', header: 'Work Name', type: 'custom', template: 'workCostNameCell' },
    { field: 'material', header: 'Material', type: 'custom', template: 'materialCell' },
    { field: 'wasteFactor', header: 'Waste Factor', type: 'custom', template: 'wasteFactorCell' },
    { field: 'unitWeight', header: 'Unit Weight', type: 'custom', template: 'unitWeightCell' },
    { field: 'unitCost', header: 'Unit Cost', type: 'custom', template: 'unitCostCell' },
    { field: 'taxOtPercent', header: 'Tax/OT %', type: 'custom', template: 'taxOtPercentCell' },
];

export const VENDOR_LABOURS_COLUMNS: TableColumn[] = [
    { field: 'workName', header: 'Work Name', type: 'custom', template: 'workCostNameCell' },
    { field: 'labour', header: 'Labour', type: 'custom', template: 'labourCell' },
    { field: 'unitCostPerHr', header: 'Unit Cost/Hr', type: 'custom', template: 'unitCostPerHrCell' },
    { field: 'taxOtPercent', header: 'Tax/OT %', type: 'custom', template: 'taxOtPercentCell' },
    { field: 'quantity', header: 'Quantity', type: 'custom', template: 'quantityCell' },
];

export const VENDOR_EQUIPMENTS_COLUMNS: TableColumn[] = [
    { field: 'workName', header: 'Work Name', type: 'custom', template: 'workCostNameCell' },
    { field: 'equipment', header: 'Equipment', type: 'custom', template: 'equipmentCell' },
    { field: 'unitCostPerHr', header: 'Unit Cost/Hr', type: 'custom', template: 'unitCostPerHrCell' },
    { field: 'taxOtPercent', header: 'Tax/OT %', type: 'custom', template: 'taxOtPercentCell' },
    { field: 'quantity', header: 'Quantity', type: 'custom', template: 'quantityCell' },
];

export const VENDOR_TABLE_CONFIG: TableConfig = {
    paginator: false,
    emptyMessage: 'No data',
};

// Materials has 6 columns — tableClass forces table-layout: fixed; width: 120% so the 6th column scrolls in
export const VENDOR_MATERIALS_TABLE_CONFIG: TableConfig = {
    paginator: false,
    emptyMessage: 'No data',
    tableClass: 'vendor-materials-table',
};
